import { post } from '@sales-center/common'
import { ServiceConfig } from '@user/store/services/config'
import { IResultMetadata } from 'dromo-uploader-react'
import { toast } from '@sales-center/components'

export async function SaveResults(
  tempApiKey: string | undefined,
  results: IResultMetadata,
) {
  if (!tempApiKey) {
    toast.error('Could not save import results')
  }

  const url = `${ServiceConfig.baseAPIUrl}${ServiceConfig.import.saveResults}`
  try {
    const response = await post(url, { tempApiKey, results })

    if (!response.ok) {
      toast.error('Could not save import results')
    }
  } catch {
    toast.error('Could not save import results')
  }
}
